<template>
  <vue-easy-lightbox
    :visible="lightboxVisible"
    :imgs="lightboxImgs"
    :index="lightboxIndex"
    @hide="onHideLightbox"
  ></vue-easy-lightbox>
  <div>
    <div v-if="show" class="modal-backdrop fade show"></div>
    <div :class="['modal', 'fade', { show: show }]" role="dialog">
      <div
        v-if="!isTaskHistory"
        class="modal-dialog modal-dialog-centered modal-xl"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Chi tiết công việc đã lưu trữ</h5>
            <button
              type="button"
              class="close"
              @click="close"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div
            class="modal-body modal-body-split"
            v-if="task"
            ref="modalBodySplit"
          >
            <div class="main-content-column" ref="mainContentColumn">
              <ul
                class="nav nav-pills nav-fill mb-3"
                id="taskTab"
                role="tablist"
              >
                <li class="nav-item" role="presentation">
                  <a
                    class="nav-link"
                    :class="{ active: activeTab === 'details' }"
                    id="details-tab"
                    href="#"
                    @click.prevent="activeTab = 'details'"
                    role="tab"
                    >Chi tiết công việc</a
                  >
                </li>
                <li class="nav-item" role="presentation">
                  <a
                    class="nav-link"
                    :class="{ active: activeTab === 'comments' }"
                    id="comments-tab"
                    href="#"
                    @click.prevent="activeTab = 'comments'"
                    role="tab"
                    >Nội dung trao đổi</a
                  >
                </li>
              </ul>

              <div class="tab-content" id="taskTabContent">
                <div
                  class="tab-pane fade"
                  :class="{ 'show active': activeTab === 'details' }"
                  id="tab-details"
                  role="tabpanel"
                >
                  <div v-if="task.tieuDe" class="mb-4 mt-3">
                    <h6 class="section-title">Tiêu đề công việc</h6>
                    <p class="task-description" style="white-space: pre-wrap">
                      {{ task.tieuDe }}
                    </p>
                  </div>
                  <div v-if="task.moTa" class="mb-4 mt-3">
                    <h6 class="section-title">Mô tả công việc</h6>
                    <p class="task-description" style="white-space: pre-wrap">
                      {{ task.moTa }}
                    </p>
                  </div>

                  <div v-if="task.attachments?.length" class="mb-4">
                    <h6 class="section-title">File đính kèm</h6>
                    <div
                      v-if="task.attachments && task.attachments.length > 0"
                      class="attachment-previews-grid mb-2"
                    >
                      <div
                        v-for="file in task.attachments"
                        :key="file.id || file.fileUrl"
                        class="attachment-preview-item"
                      >
                        <a
                          href="#"
                          download
                          target="_blank"
                          class="btn-download-overlay"
                          @click.stop.prevent="downloadFile(file)"
                          v-tooltip="'Tải xuống'"
                        >
                          <i class="fa fa-download"></i>
                        </a>
                        <a
                          v-if="
                            file.fileType && file.fileType.startsWith('image/')
                          "
                          @click="showImagePreview(task.attachments, file)"
                          class="attachment-thumbnail"
                        >
                          <img
                            :src="file.fileUrl"
                            :alt="file.originalFileName"
                          />
                        </a>
                        <a
                          v-else-if="
                            file.fileType && file.fileType.startsWith('video/')
                          "
                          class="attachment-thumbnail"
                        >
                          <video
                            :src="file.fileUrl"
                            controls
                            class="img-fluid rounded mb-2"
                          ></video>
                        </a>
                        <a
                          v-else
                          :href="file.fileUrl"
                          target="_blank"
                          class="file-icon-preview"
                        >
                          <i :class="getFileIconClass(file.fileType)"></i>
                          <span class="file-name">{{
                            file.originalFileName
                          }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  :class="{ 'show active': activeTab === 'comments' }"
                  id="tab-comments"
                  role="tabpanel"
                >
                  <div class="activity-feed-column p-0">
                    <div
                      class="d-flex justify-content-between align-items-center mb-3"
                    >
                      <h6 class="section-title">Nội dung trao đổi</h6>
                      <button
                        class="btn btn-light btn-sm dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                      >
                        {{ mapCommentType(filterType) }}
                      </button>
                      <div class="dropdown-menu">
                        <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="filterType = 'ALL'"
                        >
                          {{ mapCommentType("ALL") }}
                        </a>
                        <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="filterType = 'COMMENT'"
                        >
                          {{ mapCommentType("COMMENT") }}
                        </a>
                        <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="filterType = 'REPORT'"
                        >
                          {{ mapCommentType("REPORT") }}
                        </a>
                        <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="filterType = 'PROPOSAL'"
                        >
                          {{ mapCommentType("PROPOSAL") }}
                        </a>
                        <a
                          class="dropdown-item"
                          href="#"
                          @click.prevent="filterType = 'URGENT'"
                        >
                          {{ mapCommentType("URGENT") }}
                        </a>
                      </div>
                    </div>

                    <div class="activity-feed-list" ref="activityFeedColumn">
                      <div
                        v-for="item in displayedActivities"
                        :key="item.id"
                        class="media mb-3"
                      >
                        <div v-if="item.user.avatar" class="avatar mr-3">
                          <img :src="item.user.avatar" />
                        </div>
                        <div
                          v-else-if="item.user.name"
                          class="avatar-placeholder mr-3"
                        >
                          <span>{{
                            item.user.name.substring(0, 2).toUpperCase()
                          }}</span>
                        </div>
                        <div class="media-body">
                          <div class="d-flex justify-content-between">
                            <div class="item-header">
                              <strong class="mr-1">{{ item.user.name }}</strong>
                              <span class="text-muted small">
                                <span v-if="item.corrected">
                                  <i class="la la-history"></i> Đã sửa:
                                  {{ item.timesupdate }}
                                </span>
                                <span v-else>{{ item.timestamp }}</span>
                                <span
                                  v-if="item.type === 'REPORT'"
                                  class="activity-tag activity-tag-report"
                                  >Báo cáo: Cột "{{
                                    item.workColumn?.tenCot
                                  }}"</span
                                >
                                <span
                                  v-if="item.type === 'PROPOSAL'"
                                  class="activity-tag activity-tag-proposal"
                                  >Đề xuất: Cột "{{
                                    item.workColumn?.tenCot
                                  }}"</span
                                >
                                <span
                                  v-if="item.type === 'URGENT'"
                                  class="activity-tag activity-tag-urgent"
                                  >Khẩn cấp: Cột "{{
                                    item.workColumn?.tenCot
                                  }}"</span
                                >
                              </span>
                            </div>
                            <i
                              v-if="item.isPinned"
                              class="fa fa-thumb-tack text-primary"
                              title="Đã ghim"
                            ></i>
                          </div>

                          <div
                            v-if="item.type === 'activity'"
                            class="activity-content mt-1 text-muted"
                          >
                            <em>{{ item.actionText }}</em>
                          </div>

                          <div v-else>
                            <div
                              class="comment-content card mt-1 mb-0"
                              :class="[
                                {
                                  pinned: item.isPinned,
                                  'comment--glow':
                                    +item.id === +highlightedCommentId,
                                },
                                getActivityItemClass(item),
                              ]"
                              :data-comment-id="item.id"
                              :id="`comment-${item.id}`"
                            >
                              <div class="card-body p-2">
                                <p
                                  class="comment-content mb-1"
                                  v-if="item.content"
                                  v-html="item.content"
                                ></p>
                                <div
                                  v-if="
                                    item.attachments && item.attachments.length
                                  "
                                  class="comment-attachment mt-2 attachment-previews-grid"
                                >
                                  <div
                                    v-for="(file, index) in item.attachments"
                                    :key="index"
                                    class="attachment-preview-item"
                                  >
                                    <a
                                      href="#"
                                      download
                                      target="_blank"
                                      class="btn-download-overlay"
                                      @click.stop.prevent="downloadFile(file)"
                                      v-tooltip="'Tải xuống'"
                                    >
                                      <i class="fa fa-download"></i>
                                    </a>
                                    <a
                                      v-if="file.fileType.startsWith('image/')"
                                      href="#"
                                      @click.prevent="
                                        showImagePreview(item.attachments, file)
                                      "
                                      class="attachment-thumbnail"
                                    >
                                      <img
                                        :src="file.fileUrl"
                                        class="img-fluid rounded"
                                        alt="Preview"
                                      />
                                    </a>
                                    <video
                                      v-else-if="
                                        file.fileType.startsWith('video/')
                                      "
                                      :src="file.fileUrl"
                                      controls
                                      class="comment-attachment-video img-fluid rounded"
                                    ></video>
                                    <a
                                      v-else
                                      :href="file.fileUrl"
                                      target="_blank"
                                      :title="file.originalFileName"
                                      class="file-icon-preview"
                                    >
                                      <i
                                        :class="getFileIconClass(file.fileType)"
                                      ></i>
                                      <span class="file-name">{{
                                        file.originalFileName
                                      }}</span>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="totalPages > 1"
                      class="d-flex justify-content-center align-items-center"
                    >
                      <nav>
                        <ul class="pagination mb-0">
                          <li
                            class="page-item"
                            :class="{ disabled: currentPage === 0 }"
                          >
                            <a
                              class="page-link"
                              href="#"
                              @click.prevent="goToPage(currentPage - 1)"
                              >Trước</a
                            >
                          </li>
                          <li
                            class="page-item"
                            v-for="page in visiblePages"
                            :key="page"
                            :class="{ active: currentPage === page - 1 }"
                          >
                            <a
                              v-if="page !== '...'"
                              class="page-link"
                              href="#"
                              @click.prevent="goToPage(page - 1)"
                              >{{ page }}</a
                            >
                            <span v-else class="page-link">...</span>
                          </li>
                          <li
                            class="page-item"
                            :class="{
                              disabled: currentPage === totalPages - 1,
                            }"
                          >
                            <a
                              class="page-link"
                              href="#"
                              @click.prevent="goToPage(currentPage + 1)"
                              >Sau</a
                            >
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="sidebar-column">
              <div class="mb-4">
                <button
                  type="button"
                  class="btn btn-info mr-2 btn-block"
                  @click="toggleTaskHistory()"
                >
                  <i class="las la-history"></i>
                  Xem Lịch sử hoạt động
                </button>
              </div>

              <div class="sidebar-info-block">
                <h6 class="card-section-title">Không gian làm việc</h6>
                <p class="mb-1">
                  <i class="fa fa-folder-open-o fa-fw mr-2 text-muted"></i
                  ><strong>{{ task.workspace?.tieuDe }}</strong>
                </p>
                <p class="mb-1">
                  <i class="fa fa-user-o fa-fw mr-2 text-muted"></i>Người phụ
                  trách:
                  <strong>{{ task.workspace?.author?.hoTen }}</strong>
                </p>
                <div v-if="task.workspace?.managers?.length" class="mb-3">
                  <i class="fa fa-users fa-fw mr-2 text-muted"></i>Quản lý:
                  <span
                    v-for="(manager, index) in task.workspace.managers"
                    :key="manager.idNguoiDung"
                  >
                    <strong>{{ manager.hoTen }}</strong
                    >{{
                      index < task.workspace.managers.length - 1 ? ", " : ""
                    }}
                  </span>
                </div>
              </div>

              <div class="sidebar-info-block">
                <h6 class="card-section-title">Thông tin công việc</h6>
                <table class="table table-sm table-borderless info-table">
                  <tbody>
                    <tr>
                      <td>Trạng thái:</td>
                      <td>
                        <span class="badge badge-secondary">{{
                          "Lưu trữ"
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Ưu tiên:</td>
                      <td>
                        <strong :class="priorityClass(task.doUuTien)">{{
                          priorityText(task.doUuTien)
                        }}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>Độ khó:</td>
                      <td>
                        <span
                          v-if="task.doKho"
                          class="badge"
                          :class="{
                            'badge-success': task.doKho === 'EASY',
                            'badge-warning': task.doKho === 'MEDIUM',
                            'badge-danger': task.doKho === 'HARD',
                          }"
                        >
                          {{
                            task.doKho === "EASY"
                              ? "Dễ"
                              : task.doKho === "MEDIUM"
                              ? "Vừa"
                              : "Khó"
                          }}
                        </span>
                        <span v-else class="text-muted">Chưa đặt</span>
                      </td>
                    </tr>

                    <tr>
                      <td>Thẻ Tag:</td>
                      <td>
                        <div
                          v-if="
                            task.tags &&
                            typeof task.tags === 'string' &&
                            task.tags.length > 0
                          "
                        >
                          <span
                            v-for="(tag, index) in task.tags.split(',')"
                            :key="index"
                            class="badge badge-light border mr-1 mb-1"
                          >
                            #{{ tag.trim() }}
                          </span>
                        </div>
                        <span v-else class="text-muted">Không có</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Người tạo:</td>
                      <td>{{ task.nguoiTao?.hoTen }}</td>
                    </tr>
                    <tr>
                      <td>Ngày tạo:</td>
                      <td>{{ formatDate(task.ngayTao) }}</td>
                    </tr>
                    <tr>
                      <td>Bắt đầu:</td>
                      <td>{{ formatDate(task.ngayBatDau) }}</td>
                    </tr>
                    <tr>
                      <td>Kết thúc:</td>
                      <td>{{ formatDate(task.ngayKetThuc) }}</td>
                    </tr>
                    <tr>
                      <td>Hoàn thành:</td>
                      <td>
                        <strong class="text-success">{{
                          formatDate(task.ngayHoanThanh)
                        }}</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="task.assignedUsers?.length" class="sidebar-info-block">
                <h6 class="section-title">Người thực hiện</h6>
                <ul class="list-unstyled mb-0">
                  <li
                    v-for="user in task.assignedUsers"
                    :key="user.idNguoiDung"
                    class="media mb-2 align-items-center"
                  >
                    <img
                      :src="
                        user.avatarUrl || '/assets/img/profiles/avatar-02.jpg'
                      "
                      class="mr-3 rounded-circle"
                      width="36"
                      height="36"
                    />
                    <div class="media-body">
                      <div class="font-weight-bold">{{ user.hoTen }}</div>
                      <small class="text-muted">{{ user.email }}</small>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="modal-body" v-else>
            <div class="text-center p-5">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="close">
              Đóng
            </button>
          </div>
        </div>
      </div>

      <div v-else class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Lịch sử hoạt động</h4>
            <div>
              <button
                type="button"
                class="btn btn-light mr-2"
                @click="toggleTaskHistory()"
              >
                Xem nhiệm vụ
              </button>
              <button
                type="button"
                class="close"
                @click="close"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
            <div class="p-3 task-details-column">
              <ActivityTaskHistory v-if="task" :task-id="task.id" />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="close">
              Đóng
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import ActivityTaskHistory from "./ActivityTaskHistory.vue";
import commentService from "@/services/taskCommentService";
import VueEasyLightbox from "vue-easy-lightbox";

const props = defineProps({
  show: { type: Boolean, required: true },
  task: { type: Object, default: null },
});

const emit = defineEmits(["close"]);
const toast = useToast();
const route = useRoute();
const router = useRouter();

const close = () => emit("close");

const isTaskHistory = ref(false);
const filterType = ref("ALL");
const activities = ref([]);
const currentPage = ref(0);
const totalPages = ref(0);
const totalElements = ref(0);
const pageSize = ref(20);
const activityFeedColumn = ref(null);
const highlightedCommentId = ref(null);

const activeTab = ref("details");
const mainContentColumn = ref(null);
const modalBodySplit = ref(null);

const displayedActivities = computed(() => {
  return [...activities.value].sort((a, b) => b.isPinned - a.isPinned);
});

watch(
  () => props.show,
  async (newVal) => {
    if (newVal) {
      document.body.classList.add("modal-open");
      isTaskHistory.value = false;
      filterType.value = "ALL";
      currentPage.value = 0;
      activities.value = [];
      activeTab.value = "details";

      if (props.task && props.task.id) {
        await fetchComments();

        const focusId = getFocusCid();
        if (focusId) {
          activeTab.value = "comments";
        }
        setTimeout(() => tryFocusCommentOnce(), 300);
      }
    } else {
      document.body.classList.remove("modal-open");
    }
  },
  { immediate: true }
);

watch(filterType, () => {
  currentPage.value = 0;
  fetchComments();
});

const visiblePages = computed(() => {
  const pages = [];
  const maxVisible = 5;
  if (totalPages.value <= maxVisible + 2) {
    for (let i = 1; i <= totalPages.value; i++) pages.push(i);
  } else {
    pages.push(1);
    const current = currentPage.value + 1;
    let start = Math.max(2, current - Math.floor((maxVisible - 2) / 2));
    let end = Math.min(totalPages.value - 1, start + maxVisible - 3);
    start = Math.max(2, end - maxVisible + 3);

    if (start > 2) pages.push("...");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages.value - 1) pages.push("...");
    pages.push(totalPages.value);
  }
  return pages;
});

const goToPage = (pageNumber) => {
  if (pageNumber >= 0 && pageNumber < totalPages.value) {
    currentPage.value = pageNumber;
    fetchComments();
    nextTick(() => {
      if (activityFeedColumn.value) {
        activityFeedColumn.value.scrollTop = 0;
      }
    });
  }
};

const mapCommentType = (actionType) => {
  switch (actionType) {
    case "COMMENT":
      return "Thảo luận";
    case "REPORT":
      return "Báo cáo";
    case "PROPOSAL":
      return "Đề xuất";
    case "URGENT":
      return "Khẩn cấp";
    default:
      return "Tất cả";
  }
};

const getActivityItemClass = (item) => {
  return {
    "activity-item--report": item.type === "REPORT",
    "activity-item--proposal": item.type === "PROPOSAL",
  };
};

const fetchComments = async () => {
  if (!props.task?.id) return;

  try {
    const params = {
      page: currentPage.value,
      size: pageSize.value,
      type: filterType.value === "ALL" ? null : filterType.value,
    };

    const focusId = getFocusCid();
    if (focusId) {
      params.size = 999999;
    }

    const response = await commentService.getAllByTaskId(props.task.id, params);

    activities.value = response.data.content.map((comment) => ({
      id: Number(comment.id),
      type: comment.type,
      user: {
        name: comment.author.hoTen,
        avatar: comment.author.avatarUrl,
      },
      timestamp: formatDate(comment.ngayTao),
      timesupdate: formatDate(comment.ngaySua),
      corrected: comment.ngayTao !== comment.ngaySua,
      content: comment.content,
      isPinned: comment.pinned,
      attachments: comment.attachments || [],
      workColumn: comment.workColumn || [],
      _original: comment,
    }));
    totalPages.value = response.data.totalPages;
    totalElements.value = response.data.totalElements;

    await nextTick();
    tryFocusCommentOnce();
  } catch (error) {
    toast.error(error?.response?.data?.message || "Không thể tải bình luận.");
    console.error("Fetch comments error:", error);
    activities.value = [];
  }
};

function toggleTaskHistory() {
  isTaskHistory.value = !isTaskHistory.value;
}

function getFocusCid() {
  if (!route) return null;
  const q = route.query || {};
  return q.commentId ?? q.focusComment ?? null;
}

async function tryFocusCommentOnce() {
  const cidRaw = getFocusCid();
  if (!cidRaw) return;

  highlightedCommentId.value = Number(cidRaw);
  await nextTick();

  const cidStr = String(cidRaw);
  const el =
    document.querySelector(`[data-comment-id="${cidStr}"]`) ||
    document.getElementById(`comment-${cidStr}`);

  if (el) {
    let scroller = null;
    if (window.innerWidth >= 992) {
      scroller = mainContentColumn.value;
    } else {
      scroller = modalBodySplit.value;
    }

    if (scroller) {
      scroller.scrollTo({
        top: el.offsetTop - 20,
        behavior: "smooth",
      });
    }
    el.classList.add("comment--glow");
    setTimeout(() => el.classList.remove("comment--glow"), 2500);
  }

  if (router) {
    const q = { ...route.query };
    delete q.commentId;
    delete q.focusComment;
    router.replace({ query: q }).catch(() => {});
  }
}

const priorityText = (priorityKey) => {
  const priorities = {
    URGENT: "Khẩn cấp",
    HIGH: "Cao",
    MEDIUM: "Trung bình",
    LOW: "Thấp",
  };
  return priorities[priorityKey] || priorityKey;
};

const priorityClass = (priorityKey) => {
  switch (priorityKey) {
    case "URGENT":
      return "text-danger";
    case "HIGH":
      return "text-warning";
    case "MEDIUM":
      return "text-info";
    case "LOW":
      return "text-success";
    default:
      return "";
  }
};

const formatDate = (isoString) => {
  if (!isoString) return "N/A";
  return new Date(isoString).toLocaleString("vi-VN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const lightboxVisible = ref(false);
const lightboxIndex = ref(0);
const lightboxImgs = ref([]);

const showImagePreview = (attachments, clickedFile) => {
  const images = attachments
    .filter((att) => att.fileType?.startsWith("image/"))
    .map((att) => ({
      src: att.fileUrl,
      title: att.originalFileName,
    }));

  if (images.length === 0) return;

  const correctIndex = images.findIndex(
    (img) => img.src === clickedFile.fileUrl
  );

  lightboxImgs.value = images;
  lightboxIndex.value = correctIndex >= 0 ? correctIndex : 0;
  lightboxVisible.value = true;
};

const onHideLightbox = () => {
  lightboxVisible.value = false;
};

const getFileIconClass = (fileType) => {
  if (!fileType) return "fa fa-file-o fa-2x text-muted";
  if (fileType.includes("pdf")) return "fa fa-file-pdf-o fa-2x text-danger";
  if (fileType.includes("word")) return "fa fa-file-word-o fa-2x text-primary";
  if (fileType.includes("excel"))
    return "fa fa-file-excel-o fa-2x text-success";
  return "fa fa-file-o fa-2x text-muted";
};

// Tải file
// Thêm vào trong <script setup>

const downloadFile = async (file) => {
  if (!file || !file.fileUrl) return;

  try {
    // Cách 1: Dùng fetch để lấy dữ liệu binary của file (Force Download)
    const response = await fetch(file.fileUrl, {
      method: "GET",
      mode: "cors", // Quan trọng nếu file nằm khác domain
      cache: "no-cache",
    });

    if (!response.ok) throw new Error("Network response was not ok");

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    // Đặt tên file khi tải về
    link.setAttribute("download", file.originalFileName || "downloaded-file");

    document.body.appendChild(link);
    link.click();

    // Dọn dẹp bộ nhớ
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // Fallback: Nếu server chặn CORS hoặc lỗi mạng, mở tab mới để trình duyệt tự xử lý
    console.warn("Không thể tải trực tiếp, chuyển sang mở tab mới", error);
    window.open(file.fileUrl, "_blank");
  }
};
</script>

<style scoped>
.modal-dialog {
  max-height: 90vh;
}
.modal-content {
  height: 95vh;
  display: flex;
  flex-direction: column;
}

.modal-body:not(.modal-body-split) {
  max-height: 70vh;
  overflow-y: auto;
  padding: 1.5rem;
  flex-grow: 0;
}

.modal-body.modal-body-split {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  flex-grow: 1;
  min-height: 0;
}
.main-content-column {
  max-width: 100%;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e5e5;
}
.sidebar-column {
  max-width: 100%;
  padding: 1.5rem;
  background-color: #f8f9fa;
}

@media (min-width: 992px) {
  .modal-dialog {
    height: 90vh;
  }
  .modal-body.modal-body-split {
    flex-direction: row;
    overflow: hidden;
  }
  .main-content-column {
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
    overflow-y: auto;
    border-bottom: 0;
    border-right: 1px solid #e5e5e5;
  }
  .sidebar-column {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
    overflow-y: auto;
  }
}

.sidebar-info-block {
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
}
.sidebar-info-block:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.sidebar-info-block .info-table {
  background-color: transparent !important;
  margin-bottom: 0;
}

@media (prefers-reduced-motion: reduce) {
  .comment--glow,
  .comment--glow::after {
    animation: none !important;
    transition: none !important;
  }
}
.comment--glow {
  position: relative;
  isolation: isolate;
  background: rgba(255, 200, 0, 0.1);
  border-radius: 10px;
  transition: background 300ms ease;
}
.comment--glow::after {
  content: "";
  position: absolute;
  inset: -4px;
  border-radius: 12px;
  pointer-events: none;
  z-index: 1;
  box-shadow: 0 0 0 0 rgba(255, 200, 0, 0.65);
  animation: pulseRing 1600ms ease-out 3;
}
.comment--glow .card-body {
  position: relative;
  z-index: 2;
}
@keyframes pulseRing {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 200, 0, 0.65);
  }
  60% {
    box-shadow: 0 0 0 10px rgba(255, 200, 0, 0);
  }
  100% {
    box-shadow: 0 0 0 0px rgba(255, 200, 0, 0);
  }
}

.attachment-previews-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 10px;
}
.attachment-preview-item {
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #dee2e6;
  aspect-ratio: 1 / 1;
}
.attachment-thumbnail img,
.attachment-thumbnail video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.file-icon-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #f8f9fa;
  padding: 10px;
  text-align: center;
  text-decoration: none;
  color: #495057;
}
.file-icon-preview .file-name {
  font-size: 11px;
  margin-top: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.comment-attachment-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal.show {
  display: block;
}

.modal-header {
  border-bottom: 1px solid #e5e5e5;
  flex-shrink: 0;
}
.modal-footer {
  flex-shrink: 0;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
}
.close {
  opacity: 0.5;
  transition: opacity 0.2s;
}
.close:hover {
  opacity: 0.8;
}
h4 {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #f0f0f0;
}
.section-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
}
.task-description {
  font-size: 0.95rem;
  line-height: 1.7;
  color: #495057;
  padding: 1rem;
  background-color: #fafafa;
  border-left: 3px solid #dee2e6;
  border-radius: 4px;
}
.card {
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.card.bg-light {
  background-color: #f8f9fa !important;
  border: 1px solid #e5e5e5;
}
.card-section-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 1rem;
}
.info-table td:first-child {
  font-weight: 500;
  width: 110px;
  color: #6c757d;
  font-size: 0.875rem;
}
.info-table td:last-child {
  color: #495057;
}
.badge-secondary {
  background-color: #6c757d;
  padding: 4px 10px;
  font-weight: 500;
  font-size: 0.8rem;
}
.border-right {
  border-right: 1px solid #e5e5e5 !important;
}
.media img {
  border: 2px solid #f0f0f0;
}
.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  padding: 8px 24px;
  font-weight: 500;
}
.btn-secondary:hover {
  background-color: #5a6268;
  border-color: #545b62;
}
.avatar > img {
  height: 100%;
}
.avatar-placeholder {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}
.activity-tag {
  display: inline-block;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  border-radius: 10px;
  margin-left: 8px;
  vertical-align: middle;
}
.activity-tag-report {
  background-color: #e9f9ee;
  color: #28a745;
}
.activity-tag-proposal {
  background-color: #fff8e1;
  color: #f57c00;
}
.activity-tag-urgent {
  background-color: #fff8e1;
  color: #f50000;
}
.comment-content.card {
  background-color: #ffffff;
  border-radius: 20px;
}

.file-attachment,
.file-preview {
  padding: 8px;
  background: #f1f3f5;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  font-size: 0.8rem;
}
.action-links a {
  color: #979797;
}
:deep(.mention-pill) {
  background-color: #e0eaff;
  color: #0056b3;
  padding: 1px 5px;
  border-radius: 4px;
  font-weight: 600;
  white-space: nowrap;
}

.nav-pills {
  background-color: #f1f3f5;
  border-radius: 0.3rem;
  padding: 4px;
}
.nav-pills .nav-link {
  color: #495057;
  font-weight: 500;
  border-radius: 0.25rem;
  transition: background-color 0.2s ease, color 0.2s ease;
  padding: 0.5rem 1rem;
}
.nav-pills .nav-link.active {
  background-color: #ffffff;
  color: #007bff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.nav-pills .nav-link:hover:not(.active) {
  background-color: #e9ecef;
}
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}
.tab-content {
  padding-top: 1rem;
}
/* Định vị nút download nằm đè lên góc phải */
.attachment-preview-item {
  position: relative; /* Đảm bảo cha là relative để con absolute theo */
}

.btn-download-overlay {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #495057;
  z-index: 10; /* Đảm bảo nằm trên ảnh/video */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
  opacity: 0; /* Mặc định ẩn để giao diện sạch */
  text-decoration: none;
}

.btn-download-overlay i {
  font-size: 12px;
}

/* Chỉ hiện nút download khi hover vào ô file */
.attachment-preview-item:hover .btn-download-overlay {
  opacity: 1;
}

.btn-download-overlay:hover {
  background-color: #007bff;
  color: #ffffff;
  transform: scale(1.1);
}

/* Trên Mobile thì luôn hiện nút download vì không có hover chuột */
@media (max-width: 768px) {
  .btn-download-overlay {
    opacity: 1;
    background-color: rgba(255, 255, 255, 0.95);
  }
}
</style>
